<template>
  <div class="login-wrap">
    <!-- <img class="login-banner" src="@/assets/image/banner.png" /> -->
    <div class="login-form">
      <h4>欢迎进入健康管家<br/>请用手机号登录</h4>
      <div class="form-group">
        <!-- <img class="group-icon" src="@/assets/image/phone.png" /> -->
        <input
          class="group-input width1"
          type="tel"
          v-model="form.mobile"
          placeholder="请输入手机号码"
        />
      </div>
      <div class="form-group">
          <input class="group-input width2" type="text" v-model="verifyCode" placeholder="请输入图片验证码" />
          <div class="group-image" @click="getImage">
            <img :src="url1" class="image">
          </div>
        </div>
      <div class="form-group">
        <input
          class="group-input width2"
          type="text"
          v-model="form.smsCode"
          placeholder="请输入验证码"
        />
        <button class="group-btn" :disabled="isSend" @click="sendSms">
          {{ smsBtn }}
        </button>
      </div>
    </div>
    <button class="login-btn" :disabled="loading || disable" @click="doSubmit">
      登录
    </button>
    <p class="group-tip">没有账号，<router-link :to="{ name: 'Regist'}">去注册</router-link></p>
  </div>
  
</template>
<script type="text/javascript">
// import { checkPhone, getRandom } from "@/utils/validate";
import axios from 'axios'
export default {
  name: "UserLogin",
  data() {
    return {
      url1: '',
      verifyIdentity: '',
      verifyCode: '',
      time: 60,
      isSend: false,
      interval: null,
      form: {
        mobile: "",
        smsCode: "",
      },
      disable: true,
      loading: false,
    };
  },
  watch: {
    form: {
      deep: true,
      handler: function (newVal, oldVal) {
        var flag = true;
        for (var i in newVal) {
          var item = newVal[i];
          if (!item) {
            flag = false;
            break;
          }
        }
        this.disable = !flag;
      },
    },
  },
  computed: {
    smsBtn: function () {
      if (this.isSend) return `${this.time}s后重新发送`;
      else return "发送验证码";
    },
  },
  methods: {
    // 获得图片验证码
    getImage() {
      this.verifyIdentity = new Date().getTime() + getRandom(6)
      axios.get(this.url.domain + this.api.getCodeImage, {
        params: {
          imageUuid: this.verifyIdentity
        },
        responseType: 'blob'
      })
      .then(response => {
        let blob = response.data
        console.log(blob)
        this.url1 = window.URL.createObjectURL(blob)
      })
      .catch((error) => {
        this.$toast({
          message: error.errmsg || "获取图片验证码失败",
          duration: this.$root.toastTime,
        });
      });
    },
    sendSms() {
      //  this.$toast('提示文案');
      var base = this;
      if (!this.form.mobile) {
        this.$toast({
          message: "请输入手机号",
          duration: this.$root.toastTime,
        });
        return;
      }
      if (!this.verifyCode) {
        this.$toast({
          message: "请输入图片验证码",
          duration: this.$root.toastTime,
        });
        return;
      }
      if (!checkPhone(this.form.mobile)) {
        this.$toast({
          message: "手机号格式异常，请检查",
          duration: this.$root.toastTime,
        });
        return;
      }
      // 调用发送接口
      // this.isSend = true;
      this.request({
        url: this.url.domain + this.api.smsCode,
        method: "post",
        data: {
          mobile: this.form.mobile,
          imageUuid: this.verifyIdentity,
          imageCode: this.verifyCode
        },
      })
        .then((response) => {
          const { code, msg } = response.data
          if(code == 200) {
            this.isSend = true;
            this.time = 60;
            this.interval = setInterval(function () {
              if (base.time - 1 <= 0) {
                clearInterval(base.interval);
                base.isSend = false;
              } else base.time--;
            }, 1000);
          } else {
            this.$toast({
              message: msg,
              duration: this.$root.toastTime,
            })
            this.getImage()
          }
        })
        .catch((error) => {
          this.isSend = false;
          this.$toast({
            message: error.errmsg,
            position: "middle",
            duration: this.$root.toastTime,
          });
        });
    },
    doSubmit() {
      if (!this.form.mobile) {
        this.$toast({
          message: "请输入手机号",
          position: "middle",
          duration: this.$root.toastTime,
        });
        return;
      }
      if (!checkPhone(this.form.mobile)) {
        this.$toast({
          message: "手机号格式异常，请检查",
          position: "middle",
          duration: this.$root.toastTime,
        });
        return;
      }
      if (!this.form.code) {
        this.$toast({
          message: "请输入验证码",
          position: "middle",
          duration: this.$root.toastTime,
        });
        return;
      }
      this.loading = true;
      this.request({
        url: this.url.domain + this.api.login,
        method: "post",
        data: this.form,
      })
        .then((response) => {
          this.$toast({
            message: "登录成功",
            duration: this.$root.toastTime,
          })
          this.loginAfter(response)
        })
        .catch((error) => {
          this.loading = false;
          this.$toast({
            message: error.errmsg,
            position: "middle",
            duration: this.$root.toastTime,
          });
        });
    },
    loginAfter(response) {
      this.loading = false;
      // 清空登录信息
      this.store.commit("CLEAR_DATA", { key: "T" });
      this.store.commit("CLEAR_DATA", { key: "E" });
      this.store.commit("CLEAR_DATA", { key: "M" });
      // 设置登录信息
      this.store.commit("SET_DATA", {
        key: "T",
        value: response.data.accessToken,
      });
      this.store.commit("SET_DATA", {
        key: "E",
        value: response.data.expireTime,
      });
      this.store.commit("SET_DATA", {
        key: "M",
        value: this.form.mobile,
      });
      this.$router.push({ name: "Home" });
    }
  },
  created() {
    this.$root.background = null;
    // this.getImage()
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/function.scss";

.login-wrap {
  h4 {
    font-size: getsize(36px);
    margin-bottom: getsize(10px);
  }
  .login-banner {
    width: 100%;
  }
  .login-form {
    margin: getsize(100px) auto;
    width: 100%;
    padding: 0 getsize(40px);
    box-sizing: border-box;
      .form-group {
      display: flex;
      justify-content: space-between;
      margin-bottom: getsize(98px);
        border: 1px solid #ebebeb;

      * {
        vertical-align: middle;
        font-size: getsize(28px);
      }
      .group-icon {
        margin-right: getsize(30px);
        width: getsize(38px);
      }
      .group-input {
        padding: 0 getsize(5px);
        height: getsize(65px);
        line-height: getsize(65px);
      }
      .width1 {
        width: getsize(480px);
      }
      .width2 {
        width: getsize(260px);
      }
      .group-btn {
        padding: 0;
        width: getsize(200px);
        height: getsize(65px);
        font-size: getsize(26px);
        color: #ffffff;
        background-color: #00a0e9;
        border-radius: getsize(10px);
        border-width: 0;
      }
      .group-image {
        width: getsize(185px);
        height: getsize(62px);
        font-size: getsize(26px);
      }
      .group-btn:disabled {
        // color: $color-gray-weight;
        // background-color: $color-gray;
      }
    }
  }
  .login-btn {
    display: block;
    margin: getsize(300px) auto getsize(100px);
    width: getsize(550px);
    height: getsize(88px);
    line-height: getsize(88px);
    font-size: getsize(36px);
    color: #ffffff;
    background-color: #00a0e9;
    border-radius: getsize(45px);
    border-width: 0;
  }
  .login-btn:disabled {
    // background-color: $color-gray;
  }
  .image {
    height: getsize(60px);
    width: getsize(180px);
  }
  .group-tip {
    text-align: center;
  }
}
.loading {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  .loading-text {
      padding-left: rem(6px);
      color: #aaaaaa;
  }
  .loading-c {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #00000055;
    display: flex;
    justify-content: center;
    align-items: center;
    .c-box {
      width: 80%;
      border-radius: 10px;
      text-align: center;
      background-color: #fff;
      font-size: 14px;
      .c-text {
        text-align: center;
        padding: 40px 10px;
      }
      .c-button {
        height: 52px;
        line-height: 52px;
        font-size: 14px;
        border-top: 1px solid #00000055;
        color: #3685CB;
      }
    }
  }
}
</style>
